import { colors } from '@components/theme/styles/index';
import { faBriefcase } from '@fortawesome/pro-regular-svg-icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorPage from './errorPage';

const NoAccounts: FC = () => {
  const { t } = useTranslation('common');

  return (
    <ErrorPage
      icon={faBriefcase}
      color={colors.warning}
      message={t(
        'error.no_accounts',
        'Your organization does not have any accounts. Please contact support.',
      )}
    />
  );
};

export default NoAccounts;
